import { ITypeDocConfirmationViolation } from 'APIPackage/CatalogsModule/interfaces/ITypeDocConfirmationViolation';
import { ITypeDocConfirmationViolationSelectOption } from 'CorePackage/CatalogsModule/interfaces/ITypeDocConfirmationViolationSelectOption';

export function createTypeDocConfirmationViolationSelectOption(
  item: ITypeDocConfirmationViolation,
): ITypeDocConfirmationViolationSelectOption {
  return {
    ...item,
    label: item.name,
    value: item.code,
  };
}
